import * as core from '../../../../../../../core'

import { query } from './save-stakeholder.query'

export const RESOURCE = {
  payload: {
    alias: 'save.stakeholder',
    description: 'Creates or updates a stakeholder from the stakeholder modals',
    name: 'Save Stakeholder',
    query,
  },
  type: core.quiver.Resource.Type.MosaicAction,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicAction>
